import { useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Mail, Loader2, BadgeCheck, BellOff } from "lucide-react";

const pill = "inline-flex items-center gap-1 rounded-full text-[11px] px-2 py-0.5";

export const LeadEmail = ({ lead, onChange }) => {
  const [busy, setBusy] = useState(false);
  const find = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/leads/${lead.id}/find-email`);
      toast.success(`Found ${r.data.email}`);
      onChange();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (!lead.email && !lead.website) return null;
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-sm" data-testid="lead-email-block">
      {lead.email ? (
        <>
          <span className="flex items-center gap-1.5 text-muted-foreground" data-testid="lead-email">
            <Mail className="h-3.5 w-3.5" /> {lead.email}
          </span>
          {lead.email_source === "website" && (
            <a href={lead.email_source_url} target="_blank" rel="noreferrer"
              className={`${pill} bg-emerald-500/10 text-emerald-400 hover:underline`} data-testid="lead-email-source">
              <BadgeCheck className="h-3 w-3" /> found on website
            </a>
          )}
          {lead.email_unsubscribed && (
            <span className={`${pill} bg-rose-500/10 text-rose-400`} data-testid="lead-email-unsubscribed">
              <BellOff className="h-3 w-3" /> unsubscribed
            </span>
          )}
        </>
      ) : (
        <Button size="sm" variant="outline" onClick={find} disabled={busy} data-testid="find-email-button">
          {busy ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : <Mail className="h-3.5 w-3.5 mr-1.5" />}
          {busy ? "Checking website…" : "Find email on website"}
        </Button>
      )}
    </div>
  );
};
